module.exports = __webpack_public_path__ + "static/media/imge-1.5b5bf521.jpg";